import styled from 'styled-components';
import { cssVars } from '../../shared/lib/styledTheme';

export const TicketsPageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: ${cssVars.bgColor};
  overflow: hidden;
`;

export const LeftPanel = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${cssVars.bgSecondary};
  overflow: hidden;
`;

export const CenterPanel = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background-color: ${cssVars.bgColor};
  overflow: hidden;
`;

export const RightPanel = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${cssVars.bgSecondary};
  overflow: hidden;
`;

